import CustomerService from './../CustomerService';
import customerView from './customer-view';
import _ from "lodash";
import {
  CUSTOMER_TABLE_NAME,
  SOURCE_BIDDERS_MODAL,
  SOURCE_CONDITION_REPORT_REQUEST_MODAL,
  SOURCE_CUSTOMER_TABLE,
  SOURCE_RECEIPT_MODAL
} from "../../constants";
import CustomerSearch from "../CustomerSearch.model";
import i18n from "../../../shared/i18n";
import {store} from "@/plugins/vuex";
import CustomerIdentificationFormModel from "../models/CustomerIdentificationForm.model";
import {hasPermission} from "@/core/directives/permission";

let getDefaultTableData = (differentFields = []) => {
  let defaultFields = ['no', 'full_name', 'company_name', 'email', 'address', 'phone', 'status', 'activity', 'optin'];
  if (!hasPermission('view_customeraddress')) {
    defaultFields = defaultFields.filter(f => f !== 'address');
  }
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new CustomerSearch(),
    extraFilters: {},
    expand: 'term' + (hasPermission('view_customeraddress') ? ',display_billing_address,addresses' : ''),
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      dynamicFields: [],
      requiredFields: ['no', 'full_name'],
      defaultFields: defaultFields,
    }
  }
};

let getDefaultTableDataForAudienceCustomer = (differentFields = []) => {
  let defaultData = getDefaultTableData(differentFields);
  defaultData.toggleColumns.fields = [...defaultData.toggleColumns.fields, {
    key: 'subscribed',
    label: i18n.t('Subscribed'),
    sortable: true,
    isVisible: true,
    expand: 'subscribed'
  }];
  defaultData.toggleColumns.defaultFields.push('subscribed');
  defaultData.ordering = '-subscribed';
  return defaultData;
}

const customerIdentificationModel = new CustomerIdentificationFormModel()
let getDefaultFields = () => {
  let fields = [
    {key: 'no', label: i18n.t('No'), sortable: true, tdClass: 'no-col', isVisible: true, expand: ''},
    {
      key: 'full_name',
      label: i18n.t('Full Name'),
      sortable: true,
      tdClass: 'fullname-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'company_name',
      label: i18n.t('Company Name'),
      sortable: true,
      tdClass: 'company-name-col',
      isVisible: true,
      expand: ''
    },
    {key: 'email', label: i18n.t('Email'), sortable: true, tdClass: 'email-col', isVisible: true, expand: ''},
    {
      key: 'address',
      label: i18n.t('Billing Address'),
      sortable: true,
      tdClass: 'address-col',
      isVisible: true,
      expand: 'display_billing_address'
    },
    {key: 'phone', label: i18n.t('Phone'), sortable: true, tdClass: 'phone-col', isVisible: true, expand: ''},
    {key: 'status', label: i18n.t('Status'), sortable: true, tdClass: 'status-col', isVisible: true, expand: ''},
    {
      key: 'activity',
      label: i18n.t('Financial Activity'),
      sortable: false,
      tdClass: 'activity-col',
      isVisible: true,
      expand: '',
      exclude_from_export: true
    },
    {
      key: "account_managers",
      label: i18n.t('Account Manager'),
      sortable: false,
      isVisible: false,
      expand: 'account_managers',
      tdClass: "account-managers-col"
    },
    {key: 'optin', label: i18n.t('Optin'), sortable: true, isVisible: true, tdClass: 'optin-col', expand: ''},
    {key: 'tags', label: i18n.t('Tags'), sortable: false, isVisible: false, tdClass: 'tags-col', expand: ''},
    {
      key: 'is_company',
      label: i18n.t('Is Company'),
      sortable: true,
      tdClass: 'is-company-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'sms_optin',
      label: i18n.t('Text Message Notification Optin'),
      sortable: true,
      tdClass: 'sms-optin-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'mark_optin',
      label: i18n.t('Mark. Optin'),
      sortable: true,
      tdClass: 'mark-optin-col',
      isVisible: false,
      expand: 'mark_optin'
    },
    {
      key: 'personal_id',
      label: i18n.t('Personal ID'),
      sortable: true,
      tdClass: 'personal-id-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'client_tier',
      label: i18n.t('Client Tier'),
      sortable: true,
      tdClass: 'client-tier-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'shipping_address',
      label: i18n.t('Shipping/Collection Address'),
      sortable: true,
      tdClass: 'shipping-address-col',
      isVisible: false,
      expand: 'display_shipping_address'
    },
    {
      key: 'enable_estimate_request',
      label: i18n.t('Estimate Request'),
      sortable: true,
      tdClass: 'enable-estimate-request-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'created_data',
      label: i18n.t('Created at / Created by'),
      sortable: false,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'created_by'
    },
    {
      key: 'updated_data',
      label: i18n.t('Updated at / Updated by'),
      sortable: false,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_by'
    },
    {
      key: 'birth_date',
      label: i18n.t('Date of Birth'),
      sortable: true,
      tdClass: 'birth-date-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'is_vendor',
      label: i18n.t('Vendor'),
      sortable: true,
      tdClass: 'is-vendor-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'gender',
      label: i18n.t('Gender'),
      sortable: true,
      tdClass: 'gender-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'type',
      label: i18n.t('Type'),
      sortable: true,
      tdClass: 'type-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'accounting_code',
      label: i18n.t('Accounting Code'),
      sortable: false,
      tdClass: 'accounting_code-col',
      isVisible: false,
      expand: 'accounting_code'
    },
    {
      key: 'trust_level',
      label: i18n.t('Trust Level'),
      sortable: false,
      tdClass: 'trust_level-col',
      isVisible: false,
      expand: 'trust_level',
      exclude_from_export: true
    },
    {
      key: 'credit_card_verified_at',
      label: i18n.t('Credit Card Verified at'),
      sortable: true,
      tdClass: 'credit_card_verified_at-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'personal_identification_number',
      label: customerIdentificationModel.attributeLabels.personal_identification_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'document_type',
      label: customerIdentificationModel.attributeLabels.document_type,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'document_number',
      label: customerIdentificationModel.attributeLabels.document_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'document_issue_date',
      label: customerIdentificationModel.attributeLabels.document_issue_date,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'document_expiry_date',
      label: customerIdentificationModel.attributeLabels.document_expiry_date,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'date_of_birth',
      label: customerIdentificationModel.attributeLabels.date_of_birth,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'citizenship_code',
      label: customerIdentificationModel.attributeLabels.citizenship_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'residency_code',
      label: customerIdentificationModel.attributeLabels.residency_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'country_of_birth_code',
      label: customerIdentificationModel.attributeLabels.country_of_birth_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'place_of_issue',
      label: customerIdentificationModel.attributeLabels.place_of_issue,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'company_reg_number',
      label: customerIdentificationModel.attributeLabels.company_reg_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'company_vat_tax_number',
      label: customerIdentificationModel.attributeLabels.company_vat_tax_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'identification'
    },
    {
      key: 'vendor_lead_status',
      label: i18n.t('Vendor Lead Status'),
      sortable: true,
      tdClass: 'vendor-lead-status-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'buyer_lead_status',
      label: i18n.t('Buyer Lead Status'),
      sortable: true,
      tdClass: 'buyer-lead-status-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'identity_verification',
      label: i18n.t('Identity Verification'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'term'
    },
    {
      key: 'kyc_status_verification',
      label: i18n.t('Account/KYC Verification'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'term'
    },
    {
      key: 'exclude_from_auto_payments',
      label: i18n.t('Exclude from Auto-Payments'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'term'
    },
    {
      key: 'correspondence',
      label: i18n.t('Correspondence'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: ''
    },
    {
      key: 'live_id',
      label: i18n.t('Live ID'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: ''
    },
  ];
  const excludeFields = [];
  if (!hasPermission('view_customeridentification')) {
    excludeFields.push('identity_verification');
    excludeFields.push('kyc_status_verification');
    excludeFields.push('personal_identification_number');
    excludeFields.push('document_type');
    excludeFields.push('document_number');
    excludeFields.push('document_issue_date');
    excludeFields.push('document_expiry_date');
    excludeFields.push('date_of_birth');
    excludeFields.push('citizenship_code');
    excludeFields.push('residency_code');
    excludeFields.push('country_of_birth_code');
    excludeFields.push('place_of_issue');
    excludeFields.push('company_reg_number');
    excludeFields.push('company_vat_tax_number');
  }
  if (!hasPermission('view_customerbankaccount') || !store || !store.state.global || !store.state.global.hasStripeProvider) {
    excludeFields.push('exclude_from_auto_payments')
  }

  if (excludeFields.length) {
    fields = fields.filter(f => !excludeFields.includes(f.key));
  }
  return fields
}

export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      customer: getDefaultTableData(),
      audienceCustomersModal: getDefaultTableData(),
      conditionReports: getDefaultTableData(),
      audienceCustomer: getDefaultTableDataForAudienceCustomer()
    },
    modal: {
      show: false,
      object: null,
      source: null
    },
  },
  actions: {
    initTableData({state}) {
      state.tableData = {
        customer: getDefaultTableData(),
        audienceCustomersModal: getDefaultTableData(),
        conditionReports: getDefaultTableData(),
        audienceCustomer: getDefaultTableDataForAudienceCustomer()
      }
      return true
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new CustomerSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await CustomerService.getCustomers(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const expand = state.tableData[state.tableSource].expand;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      state.tableData[state.tableSource].expand = expand;
      dispatch('getTableData');
    },
    async getTableParams({state}, payload = null) {
      let data;
      let tableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: tableData,
        tableName: `${CUSTOMER_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...tableData.pagination,
          search: tableData.search,
          ordering: ordering,
        }
      }

      if (tableData.searchModel) {
        const searchModelData = tableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      const defaultExpand = tableData.expand
      const expand = tableData.toggleColumns.fields
        .filter(c => tableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand},${defaultExpand}`;

      if (tableData.extraFilters) {
        data = {...data, ...tableData.extraFilters};
        data.export_params = tableData.extraFilters;
      }

      return data;
    },
    showModal({commit}, {object = null, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async createCustomer({dispatch, state}, customer) {
      let response = await CustomerService.createCustomer(customer);

      if (response.success) {
        if (state.modal.source === SOURCE_BIDDERS_MODAL) {
          dispatch('bidders/updateBidderModalCustomer', response.body, {root: true});
        } else if (state.modal.source === SOURCE_RECEIPT_MODAL) {
          dispatch('receipts/updateReceiptModalCustomer', response.body, {root: true});
        } else if (state.modal.source === SOURCE_CONDITION_REPORT_REQUEST_MODAL) {
          dispatch('inventory/updateConditionalReportRequestModalCustomer', response.body, {root: true})
        }
      }

      return response;
    },
    async updateCustomer({commit, state}, customer) {
      let response = await CustomerService.updateCustomer(customer.uuid, customer);
      if (response.success && state.modal.source === SOURCE_CUSTOMER_TABLE) {
        commit('updateCustomer', response.body);
      }
      return response;
    },
    async removeCustomer({dispatch}, receipt) {
      let response = await CustomerService.removeCustomer(receipt.uuid);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async updateTableSource({state}, {extraFilters, source, clearTableData = false, expand = null}) {
      state.tableSource = source;
      if (clearTableData) {
        state.tableData[source] = getDefaultTableData();
      }
      state.tableData[source].extraFilters = extraFilters;
      if (expand) {
        state.tableData[source].expand = expand;
      }
    },
    async getModalObject({commit}, {uuid, source}) {
      let response = await CustomerService.getCustomer(uuid, 'addresses,account_managers');

      if (response.success) {
        commit('updateModalObject', {object: _.cloneDeep(response.body), source})
      }
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: state => state.modal.show = false,
    updateCustomer: (state, customer) => {
      const index = state.tableData[state.tableSource].rows.findIndex(c => c.uuid === customer.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...customer};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateModalObject: (state, {object, source}) => {
      state.modal.object = object;
      state.modal.source = source;
    },
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  },

  modules: {
    customerView: customerView
  }
}
